import { employeeServiceApi } from "../../app/employeeServiceApi";
import { API_URL } from "../../constants/apiUrl";
import {
  AdditionalDataResponseType,
  GetEmployeeAdditionalFieldDetailsResponseType,
  GetEmployeeAdditionalFieldsParams,
  GetEmployeeAdditionalFieldsResponseType,
  GetQueryArgsType,
  PatchQueryArgsType,
  RemoveAdditionalDataType,
} from "../../types";

export const employeeAdditionalFieldApi = employeeServiceApi.injectEndpoints({
  endpoints: (builder) => ({
    getEmployeeAdditionalFields: builder.query<
      GetEmployeeAdditionalFieldsResponseType,
      GetQueryArgsType<GetEmployeeAdditionalFieldsParams>
    >({
      query: (queryArgs) => ({
        url: API_URL.getEmployeeAdditionalFields,
        ...queryArgs,
      }),
      providesTags: ["GetEmployeeAdditionalFields"],
    }),
    getEmployeeAdditionalFieldDetails: builder.query<
      GetEmployeeAdditionalFieldDetailsResponseType,
      string
    >({
      query: (id) => ({
        url: `${API_URL.getEmployeeAdditionalFieldDetails}/${id}`,
      }),
      providesTags: (_, __, id) => [
        { type: "GetEmployeeAdditionalFieldDetails", id },
      ],
    }),
    addEmployeeAdditionalField: builder.mutation({
      query: (data) => ({
        url: API_URL.addEmployeeAdditionalField,
        method: "POST",
        body: data,
      }),
      invalidatesTags: (result) => {
        if (result) return ["GetEmployeeAdditionalFields"];
        return [];
      },
    }),
    updateEmployeeAdditionalField: builder.mutation<void, PatchQueryArgsType>({
      query: ({ body, id }) => ({
        url: `${API_URL.updateEmployeeAdditionalField}/${id}`,
        method: "PATCH",
        body,
      }),
      invalidatesTags: (result, _, { id }) => {
        if (result)
          return [
            "GetEmployeeAdditionalFields",
            {
              type: "GetEmployeeAdditionalFieldDetails",
              id,
            },
          ];

        return [];
      },
    }),
    getAdditionalData: builder.query<AdditionalDataResponseType, unknown>({
      query: () => API_URL.getAdditionalData,
    }),
    removeAdditionalData: builder.mutation<void, RemoveAdditionalDataType>({
      query: ({ id, businessMemberId }) => ({
        url: `${API_URL.removeAdditionalData}/${id}/${businessMemberId}`,
        method: "DELETE",
      }),
      invalidatesTags: (result, _, { id }) => {
        if (result)
          return [
            "GetEmployeeAdditionalFields",
            {
              type: "GetEmployeeAdditionalFieldDetails",
              id,
            },
          ];

        return [];
      },
    }),
  }),
});

export const {
  useGetEmployeeAdditionalFieldsQuery,
  useGetEmployeeAdditionalFieldDetailsQuery,
  useAddEmployeeAdditionalFieldMutation,
  useUpdateEmployeeAdditionalFieldMutation,
  useGetAdditionalDataQuery,
  useRemoveAdditionalDataMutation,
} = employeeAdditionalFieldApi;
